import styled from 'styled-components';
export const GroupTitle = styled.div`
  background: #e5e7f1;
  line-height: 21px;
  font-weight: 500;
  padding: 1.5px 15px;
  color: #353b60;
  position: sticky;
  top: 0;
  z-index: 1;

  &:first-child {
    margin-top: 7px;
  }

  ${({
  additionalStyled
}) => additionalStyled}
`;